<template>
  <div class="flow-container">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>当日渠道流量查询</span>
        </div>
      </template>

      <el-form :inline="true" :model="queryForm">
        <el-form-item label="项目Code" prop="projectCode">
          <el-input v-model="queryForm.projectCode" placeholder="请输入项目Code" :rules="[{ required: true, message: '请输入项目Code', trigger: 'blur' }]" />
        </el-form-item>
        <el-form-item label="版本" prop="version">
          <el-select v-model="queryForm.version" placeholder="请选择版本">
            <el-option label="v4" value="v4" />
            <el-option label="v3" value="v3" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-tooltip content="延迟15分钟左右，适用于15分钟之前的今日数据" placement="top">
            <el-button type="primary" :loading="todayLoading" :disabled="!queryForm.projectCode || todayLoading || realtimeLoading" @click="handleTodayQuery">
              今日查询
            </el-button>
          </el-tooltip>

          <el-tooltip content="通常延迟0-3分钟，适用于15分钟之内的今日数据" placement="top">
            <el-button type="primary" :loading="realtimeLoading" :disabled="!queryForm.projectCode || realtimeLoading || todayLoading" @click="handleRealtimeQuery">
              实时查询
            </el-button>
          </el-tooltip>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border style="width: 100%" :default-sort="{prop: 'channel', order: 'ascending'}">
        <el-table-column prop="channel" label="渠道" width="180" sortable />
        <el-table-column prop="pv" label="PV" width="180" sortable />
        <el-table-column prop="uv" label="UV" sortable />
        <el-table-column label="操作" width="120">
          <template #default="scope">
            <el-button size="small" @click="currentChannel = scope.row.channel; dialogVisible = true">
              查看埋点
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog v-model="dialogVisible" :title="`${currentChannel} - 自定义埋点数据`" width="60%">
      <el-table :data="customData.filter(item => item.channel === currentChannel)" border :default-sort="{prop: 'custom_type', order: 'ascending'}">
        <el-table-column prop="custom_type" label="埋点类型" sortable />
        <el-table-column prop="pv" label="PV" sortable />
        <el-table-column prop="uv" label="UV" sortable />
      </el-table>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'
// import axios from 'axios'
import { ElMessage, ElDialog } from 'element-plus'
import api from '@/utils/http';
const queryForm = ref({
  projectCode: '',
  version: 'v4'
})

const tableData = ref([])
const customData = ref([])

const decodeCustomType = (data) => {
  return data.map(item => {
    return item;
  })
}
const dialogVisible = ref(false)
const currentChannel = ref('')
const realtimeLoading = ref(false)
const todayLoading = ref(false)

const getCurrentDate = () => {
  const now = new Date()
  return {
    year: now.getFullYear().toString(),
    month: (now.getMonth() + 1).toString().padStart(2, '0'),
    day: now.getDate().toString().padStart(2, '0')
  }
}
const urlPre = "/dw" // 替换为实际的API前缀

const handleRealtimeQuery = async () => {

  realtimeLoading.value = true
  tableData.value = [] // 清空旧数据
  try {
    const { year, month, day } = getCurrentDate()
    const [flowRes, customRes] = await Promise.all([
      api.post(urlPre + '/admin/api/v1/dataWorks/proxy', {
        sqlType: 'tracking',
        isReturnResult: true,
        isStoreResult: false,
        sql: `SELECT 
          channel, count(userid) pv, count(DISTINCT userid) uv
          from mf_kafka_tracking 
          WHERE 
          projectcode = '${queryForm.value.projectCode}'
          and year = '${year}'
          and month = '${month}'
          and day = '${day}'
          and type = '${queryForm.value.version === 'v4' ? 'visit' : 'flowSource'}'
          GROUP by channel`
      }),
      api.post(urlPre + '/admin/api/v1/dataWorks/proxy', {
        sqlType: 'tracking',
        isReturnResult: true,
        isStoreResult: false,
        sql: `SELECT 
          channel,customtype as custom_type, count(userid) pv, count(DISTINCT userid) uv
          from mf_kafka_tracking 
          WHERE 
          projectcode = '${queryForm.value.projectCode}'
          and year = '${year}'
          and month = '${month}'
          and day = '${day}'
          GROUP by channel,customtype`
      })
    ]);

    if (flowRes.success && customRes.success) {
      tableData.value = flowRes.data
      customData.value = decodeCustomType(customRes.data)
    } else {
      ElMessage.error(flowRes.errorMsg || customRes.errorMsg || '查询失败')
    }
  } catch (error) {
    ElMessage.error('接口请求失败')
    console.error(error)
  } finally {
    realtimeLoading.value = false
  }
}

const handleTodayQuery = async () => {
  if (!queryForm.value.projectCode) {
    ElMessage.warning('请输入项目Code')
    return
  }

  todayLoading.value = true
  tableData.value = [] // 清空旧数据
  try {
    const today = new Date()
    const todayStr = today.toISOString().split('T')[0]

    const [flowRes, customRes] = await Promise.all([
      api.post(urlPre + '/admin/api/v1/dataWorks/proxy', {
        sqlType: 'tracking',
        isReturnResult: true,
        isStoreResult: false,
        sql: `SELECT 
          channel, count(user_id) pv, count(DISTINCT user_id) uv
          from mf_kafka_tracking_today  
          WHERE 
          project_code = '${queryForm.value.projectCode}'
            AND t_timestamp >= TO_MILLIS(DATETIME '${todayStr} 00:00:00') 
            AND t_timestamp <= TO_MILLIS(DATETIME '${todayStr} 23:59:59')
            and type = '${queryForm.value.version === 'v4' ? 'visit' : 'flowSource'}'
          GROUP by channel`
      }),
      api.post(urlPre + '/admin/api/v1/dataWorks/proxy', {
        sqlType: 'tracking',
        isReturnResult: true,
        isStoreResult: false,
        sql: `SELECT 
          channel,custom_type as custom_type, count(user_id) pv, count(DISTINCT user_id) uv
          from mf_kafka_tracking_today  
          WHERE 
          project_code = '${queryForm.value.projectCode}'
            AND t_timestamp >= TO_MILLIS(DATETIME '${todayStr} 00:00:00') 
            AND t_timestamp <= TO_MILLIS(DATETIME '${todayStr} 23:59:59')
          GROUP by channel,custom_type`
      })
    ]);

    if (flowRes.success && customRes.success) {
      tableData.value = flowRes.data
      customData.value = decodeCustomType(customRes.data)
    } else {
      ElMessage.error(flowRes.errorMsg || customRes.errorMsg || '查询失败')
    }
  } catch (error) {
    ElMessage.error('接口请求失败')
    console.error(error)
  } finally {
    todayLoading.value = false
  }
}
</script>

<style scoped>
.flow-container {
  padding: 20px;
}
.card-header {
  font-size: 18px;
  font-weight: bold;
}
.el-select {
  width: 120px;
}
</style>
